import { DedupeMixin, wasApplied } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/mixins/dedupe.js';
import { debug } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/utils/debug.js';
import { dispatchFormDataEvent, getFormDataEntries } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/utils/formdata.js';
import { emit } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/utils/event.js';
/**
 * @param Base The base class.
 * @returns A mix-in containing form event listener initializers and teardowns.
 *
 * Subclasses execute `_handleFormData` and `_handleFormSubmit` event handlers.
 */
export const FormRegistrationMixin = (Base) => {
    if (wasApplied(FormRegistrationMixin, Base)) {
        return Base;
    }
    class Mixin extends Base {
        firstUpdated(changedProperties) {
            var _a, _b;
            super.firstUpdated(changedProperties);
            (_a = this.form) !== null && _a !== void 0 ? _a : (this.form = this.closest('cipublic-form'));
            if (!this.form && this.getRootNode().host) {
                // @ts-ignore TODO Fix typing
                this.form = this.getRootNode().host.closest('cipublic-form');
            }
            const { form } = this;
            if (form) {
                (_b = form === null || form === void 0 ? void 0 : form._form) === null || _b === void 0 ? void 0 : _b.addEventListener('submit', this._handleFormSubmit.bind(this));
                form === null || form === void 0 ? void 0 : form._form.addEventListener('formdata', this.handleFormData.bind(this));
            }
        }
        _handleFormSubmit(event) {
            var _a;
            const { target } = event;
            // dispatches 'FormData' event (calls 'handleFormData')
            // TODO - remove fallback when Android Firefox supported
            // https://caniuse.com/mdn-api_htmlformelement_formdata_event
            'FormDataEvent' in window ? new FormData(target) : dispatchFormDataEvent(target);
            // prevent the default form submission behavior
            // allows custom apps to post data differently (fetch, etc..)
            if ((_a = this.form) === null || _a === void 0 ? void 0 : _a.override) {
                event.preventDefault();
            }
        }
        handleFormData(event) {
            const { formData } = event;
            const { deregistered, enableDataParsing, name, value } = this;
            if (!deregistered) {
                if (this._name === 'checkgroup') {
                    enableDataParsing
                        ? formData.set(`${name}`, JSON.parse(JSON.stringify(value)))
                        : formData.set(`${name}`, JSON.stringify(value));
                }
                else {
                    formData.set(name, value);
                }
            }
            else {
                if (formData.has(name)) {
                    formData.delete(name);
                }
            }
            if (debug()) {
                console.log(getFormDataEntries(formData));
            }
            // emit event for custom apps to await and act on data (fetch, etc...)
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            emit(this.form, 'formdata-complete', { detail: { formDataEvent: event } });
        }
        disconnectedCallback() {
            var _a, _b;
            super.disconnectedCallback();
            const { form } = this;
            if (form) {
                (_a = form === null || form === void 0 ? void 0 : form._form) === null || _a === void 0 ? void 0 : _a.removeEventListener('submit', this._handleFormSubmit.bind(this));
                (_b = form === null || form === void 0 ? void 0 : form._form) === null || _b === void 0 ? void 0 : _b.removeEventListener('formdata', this.handleFormData.bind(this));
            }
        }
    }
    DedupeMixin(FormRegistrationMixin, Mixin);
    // @ts-ignore TODO Fix typing
    return Mixin;
};
//# sourceMappingURL=form-registration.js.map